import React, {useEffect} from 'react';
import SearchBar from "../components/SearchBar";
import {useNavigate} from "react-router-dom";

import ProductGroups from "../components/ProductGroups";

import Navbar from "../../../layouts/Navbar";
import Alerts from "../components/Alerts";
import HideOnScroll from "../components/HideOnScroll";
import HelpSection from "../components/HelpSection";
const AllCategoriesPage = () => {
    const navigate = useNavigate();
    const config = window.APP_CONFIG;

    useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        if(token) {
            if(window.localStorage.getItem("needRegistration") === '1'){
                navigate('/register');
            }
        }
        else {
            if(config.shopping_app_settings.need_login > 0 ) {
                navigate('/login');
            }
        }

    }, []);

    return (
        <div className='bg-white all-category-page' style={{minHeight: '100vh'}}>
            <HideOnScroll direction="up">
                <div className="top-fixed">
                    <Alerts/>
                    <SearchBar/>
                </div>
            </HideOnScroll>
            <div className='mt-5'>
                &nbsp;
            </div>

            <ProductGroups showAll={true}/>
            <HelpSection/>
            <HideOnScroll direction="down">
                <Navbar/>
            </HideOnScroll>
        </div>
    );
};

export default AllCategoriesPage;